import React, { useEffect } from 'react'
import Hero from '../components/company/Hero'
import Team from '../components/company/Team'

const Company = () => {

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])

  return (
    <div className='h-fit w-full' >
        <Hero />
        <Team />
    </div>
  )
}

export default Company
